export default "__VITE_ASSET__BBCNWOc6__"